import { render, staticRenderFns } from "./CoreView.vue?vue&type=template&id=6f09ae3a"
import script from "./CoreView.vue?vue&type=script&lang=js"
export * from "./CoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports